<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <b-row v-if="loaded" class="mx-0 mb-3">
      <b-col>
        <b-card no-body class>
          <b-tabs card content-class="mt-3" :key="render">
            <b-tab title="Profil" active>
              <b-row>
                <b-col lg="12" v-if="!_new">
                  <b-alert
                    show
                    variant="secondary"
                    v-if="!debtor.open_warrants"
                  >
                    Ce débiteur n'a pas de mandats ouverts ou suspendus. Dès
                    lors vous pouvez modifier son adresse sans devoir
                    réinitialiser les procédures courriers et mettre à jour les
                    mandats
                  </b-alert>
                  <b-alert v-else show variant="warning">
                    Ce débiteur a {{ debtor.open_warrants }} mandat ouvert(s) ou
                    suspendu(s)
                    <span v-if="debtor.open_warrants_diff_add.length > 0">
                      dont {{ debtor.open_warrants_diff_add.length }} avec une
                      adresse courrier différente de celle du débiteur. Cliquez
                      sur l'onglet <strong>Changement d'adresse</strong> pour
                      gérer la situation
                    </span>
                  </b-alert>
                </b-col>
                <template v-if="debtor.open_warrants_diff_add.length > 0">
                  <b-col sm="12" lg="12">
                    <b-card
                      class="mb-2 bg-light shadow"
                      header-text-variant="light"
                      header-tag="h6"
                    >
                      <b-row>
                        <b-col lg="12">
                          <h6>Changement d'adresse</h6>
                          <b-table
                            :items="debtor.open_warrants_diff_add"
                            :fields="open_warrants_fields"
                            striped
                            hover
                            responsive
                          >
                            <template v-slot:cell(creancier)="data">
                              <b-link
                                :to="{
                                  name: 'creditorView',
                                  params: { id: data.item.creancierID },
                                }"
                              >
                                {{ data.item.creancier }}
                              </b-link>
                            </template>
                            <template v-slot:cell(ID)="data">
                              <b-link
                                :to="{
                                  name: 'warrantView',
                                  params: { id: data.item.ID },
                                }"
                              >
                                {{ data.item.ID }}
                              </b-link>
                            </template>
                            <template v-slot:cell(arrangementID)="data">
                              <b-link
                                v-if="data.item.arrangementID != 0"
                                :to="{
                                  name: 'settlement',
                                  params: { id: data.item.arrangementID },
                                }"
                              >
                                {{ data.item.arrangementID }}
                              </b-link>
                              <span v-else>N/A</span>
                            </template>
                            <template v-slot:cell(reinit_procedure)="data">
                              <b-checkbox
                                v-model="data.item.reinit_procedure"
                              ></b-checkbox>
                            </template>
                            <template v-slot:cell(update_address)="data">
                              <b-checkbox
                                v-model="data.item.update_address"
                              ></b-checkbox>
                            </template>
                          </b-table>
                        </b-col>
                        <b-col lg="12">
                          <b-button @click="save()"
                            >Confirmer la mise à jour des adresses
                            courrier</b-button
                          >
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-col>
                </template>
                <b-col sm="12" lg="6">
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                  >
                    <b-row>
                      <b-col lg="6">
                        <mh-input
                          field="tva"
                          :readonly="!editable"
                          :table="debtor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          field="registre"
                          :readonly="!editable"
                          :table="debtor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                    </b-row>
                  </b-card>
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                  >
                    <b-row>
                      <b-col lg="6">
                        <mh-input
                          field="nom_soc"
                          :readonly="!editable"
                          :table="debtor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          field="ID"
                          readonly
                          :table="debtor"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="4">
                        <mh-input
                          field="rechercheAdresse"
                          :readonly="!editable"
                          :table="debtor"
                          labelColsLg="10"
                          @change="presave()"
                        >
                        </mh-input>
                      </b-col>
                      <b-col lg="4">
                        <mh-input
                          field="toCheck"
                          label="À vérifier"
                          :readonly="!editable"
                          :table="debtor"
                          labelColsLg="10"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="4">
                        <mh-input
                          field="particulier"
                          label="Particulier"
                          :readonly="!editable"
                          :table="debtor"
                          labelColsLg="10"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="12">
                        <b-row>
                          <mh-input
                            mh-class="col-12"
                            field="nom"
                            :readonly="!editable"
                            :table="debtor"
                            labelColsLg="2"
                            @change="presave()"
                          >
                          </mh-input>
                          <mh-input
                            mh-class="col-6"
                            field="prenom"
                            :readonly="!editable"
                            :table="debtor"
                            @change="presave()"
                          ></mh-input>
                          <mh-input
                            mh-class="col-6"
                            field="date_naissance"
                            :readonly="!editable"
                            :table="debtor"
                            @change="presave()"
                          >
                          </mh-input>
                        </b-row>
                      </b-col>
                      <b-col sm="6">
                        <mh-input
                          field="titredebiteurID"
                          :readonly="!editable"
                          :table="debtor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <mh-input
                        mh-class="col-3"
                        field="private"
                        :readonly="!editable"
                        :table="debtor"
                        @change="presave()"
                      ></mh-input>
                      <mh-input
                        mh-class="col-3"
                        field="sexe"
                        :readonly="!editable"
                        :table="debtor"
                        @change="presave()"
                      ></mh-input>
                    </b-row>
                    <mh-input
                      field="rue1"
                      :readonly="!editable"
                      :table="debtor"
                      debounce="400"
                      :autocomplete="{ field: 'google.places' }"
                      @enter="suggestAddress($event)"
                      labelColsLg="2"
                      @change="presave()"
                    >
                    </mh-input>
                    <mh-input
                      field="rue2"
                      :readonly="!editable"
                      :table="debtor"
                      labelColsLg="2"
                      @change="presave()"
                    ></mh-input>
                    <b-row>
                      <b-col sm="3">
                        <mh-input
                          field="localite"
                          :readonly="!editable"
                          :table="debtor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col sm="3">
                        <mh-input
                          field="codepostal"
                          :readonly="!editable"
                          :table="debtor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col sm="3">
                        <mh-input
                          field="pays"
                          :readonly="!editable"
                          :table="debtor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col sm="3">
                        <mh-input
                          field="langue"
                          :readonly="!editable"
                          :table="debtor"
                          @change="reloadTitres()"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <b-table
                      v-if="!_new && debtor.debiteur_adresses.length > 0"
                      hover
                      caption-top
                      :fields="addressesFields"
                      :items="debtor.debiteur_adresses"
                      responsive
                    >
                      <template v-slot:table-caption
                        >Historique des adresses</template
                      >
                      <template v-slot:cell(date)="data">{{
                        toDate(data.item.date)
                      }}</template>
                      <template v-slot:cell(nom)="data">
                        {{ data.item.nom_soc }} {{ data.item.prenom }}
                        {{ data.item.nom }}
                      </template>
                      <template v-slot:cell(adresse)="data"
                        >{{ data.item.rue1 }} {{ data.item.rue2 }}</template
                      >
                      <template v-slot:cell(codepostal)="data"
                        >{{ data.item.codepostal }},
                        {{ data.item.localite }}</template
                      >
                    </b-table>
                  </b-card>
                </b-col>

                <b-col lg="6">
                  <b-card
                    v-if="!_new && loaded && debtor.debiteur_mandats.length > 0"
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                  >
                    <b-row>
                      <b-col lg=12>
                        <h6 class="card-subtitle">Mandats Ouverts</h6>
                          <b-table
                            id="mandatsTable"
                            striped
                            hover
                            responsive
                            :fields="mandatsFields"
                            :items="debtor.debiteur_mandats"
                            class="mt-3"
                          >
                            <template v-slot:cell(ID)="data">
                              <b-link
                                :to="{
                                  name: 'warrantView',
                                  params: { id: data.item.ID },
                                }"
                              >
                                {{ data.item.ID }}
                              </b-link>
                            </template>
                            <template v-slot:cell(date_ouverture)="data">{{
                              toDate(data.item.date_ouverture)
                            }}</template>
                            <template v-slot:cell(solde_du)="data">
                              <div>
                                Solde total :
                                <span class="float-right"
                                  >{{
                                    Number(
                                      data.item.soldeDu.soldeTotal
                                    ).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  }}
                                  €</span
                                >
                              </div>
                              <div>
                                Indemnités :
                                <span class="float-right"
                                  >{{
                                    Number(
                                      data.item.soldeDu.indemniteTotal
                                    ).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  }}
                                  €</span
                                >
                              </div>
                              <div>
                                Payements :
                                <span class="float-right"
                                  >-
                                  {{
                                    Number(
                                      data.item.soldeDu.payementTotal
                                    ).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  }}
                                  €</span
                                >
                              </div>
                              <hr />
                              <div>
                                <strong>
                                  Sous-total :
                                  <span class="float-right"
                                    >{{
                                      Number(
                                        data.item.soldeDu.soldeDu
                                      ).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    }}
                                    €</span
                                  >
                                </strong>
                              </div>
                            </template>
                            <template v-slot:bottom-row>
                              <td />
                              <td />
                              <td />
                              <td />
                              <td>
                                <strong
                                  >Total :<span class="float-right"
                                    >{{
                                      Number(mandatsTotal).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    }}
                                    €</span
                                  ></strong
                                >
                              </td>
                            </template>
                          </b-table>
                      </b-col>
                    </b-row>
                  </b-card>

                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                  >
                    <b-row>
                      <b-col lg="12">
                        <h6 class="card-subtitle">N° de téléphone</h6>
                        <mh-table-editable
                          numbering
                          ref="telephoneTable"
                          class="mt-3"
                          small
                          v-model="debtor.debiteur_tel"
                          :fields="fieldsTel"
                          @change="presave()"
                        >
                        </mh-table-editable>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          field="email"
                          :readonly="!editable"
                          :table="debtor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          field="autreEmail"
                          :readonly="!editable"
                          :table="debtor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="12">
                        <mh-input
                          field="url"
                          :readonly="!editable"
                          :table="debtor"
                          labelColsLg="2"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                    </b-row>
                  </b-card>
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                  >
                    <ul style="list-style-type: none; padding-left: 0">
                      <li>
                        <a
                          target="_blank"
                          :href="
                            'https://www.facebook.com/search/top/?q=' +
                              encodeURIComponent(
                                debtor.prenom.value + ' ' + debtor.nom.value
                              )
                          "
                          >Chercher sur Facebook</a
                        >
                      </li>
                      <li>
                        <a
                          :href="
                            'https://kbopub.economie.fgov.be/kbopub/zoeknummerform.html?lang=fr&nummer=' +
                              debtor.tva.value +
                              '&actionLu=Recherche'
                          "
                          target="_blank"
                          >Rechercher via la Banque Carrefour</a
                        >
                      </li>
                      <li>
                        <a
                          :href="
                            'http://www.ejustice.just.fgov.be/cgi_tsv/tsv_rech.pl?language=fr&btw=' +
                              debtor.tva.value +
                              '&liste=Liste'
                          "
                          target="_blank"
                          >Rechercher les publications</a
                        >
                      </li>
                      <li>
                        <a
                          :href="
                            'http://www.ejustice.just.fgov.be/cgi/rech.pl?language=fr&text1=' +
                              debtor.tva.value +
                              '&liste=Liste'
                          "
                          target="_blank"
                          >Rechercher Personnes Physiques</a
                        >
                      </li>
                      
                    </ul>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>

            <b-tab v-if="debtor.tva.value !== '' && bceLoaded" title="BCE">
              <b-row>
                <b-col lg="4" sm="12">
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                  >
                    <b-list-group>
                      <b-list-group-item
                        variant="primary"
                        v-for="(info, index) in bce.entity"
                        :key="index"
                      >
                        <b-row>
                          <b-col lg="3">{{ index }}</b-col>
                          <b-col lg="9">
                            <div v-for="(line, i) in info" :key="i">
                              {{ line }}
                            </div>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card>
                </b-col>
                <b-col v-if="bceLoaded" lg="4" sm="12">
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                  >
                    <b-list-group>
                      <b-list-group-item
                        variant="primary"
                        v-for="(info, index) in bce.unity"
                        :key="index"
                      >
                        <b-row>
                          <b-col lg="3">{{ index }}</b-col>
                          <b-col lg="9">
                            <div v-for="(line, i) in info" :key="i">
                              {{ line }}
                            </div>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card>
                </b-col>
                <b-col v-if="publicationsLoaded" lg="4" sm="12">
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                  >
                    <b-table
                      v-if="publications.length > 0"
                      striped
                      hover
                      responsive
                      :fields="pubfields"
                      :items="publications"
                    >
                      <template v-slot:cell(infos)="data">
                        <div
                          v-for="(info, index) in data.item.infos"
                          :key="index"
                        >
                          {{ info }}
                        </div>
                      </template>
                      <template v-slot:cell(document)="data">
                        <span v-if="data.item.document">
                          <b-button
                            variant="info"
                            target="_blank"
                            :href="data.item.document"
                          >
                            <b-icon icon="file-earmark-arrow-down"></b-icon>
                          </b-button>
                        </span>
                      </template>
                    </b-table>
                    <b-card-body v-else>
                      <b-alert show>Pas de publications au moniteur</b-alert>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab v-if="debtor.tva.value !== ''" title="Centrale des bilans">
              <b-row>
                <b-col lg="12" sm="12">
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                    header-tag="h6"
                  >
                    <h6>Banque Nationale de Belgique / Centrale des bilans</h6>
                    <template v-if="debtor.nbb.length">
                      <b-table
                        striped
                        hover
                        responsive
                        :fields="nbb_fields"
                        :items="debtor.nbb"
                      >
                        <template v-slot:cell(actions)="data">
                          <b-button
                            title="PDF du bilan"
                            icon
                            size="sm"
                            class="btn-sm ml-2"
                            variant="secondary"
                            target="_blank"
                            :href="getNbbUrl(data.item.ID)"
                          >
                            <b-icon-printer-fill></b-icon-printer-fill>
                          </b-button>
                        </template>
                      </b-table>
                    </template>
                    <template v-else>
                      <b-alert show>
                        Vous n'avez pas encore de données synchronisées ce
                        débiteur avec la BNB
                      </b-alert>
                    </template>
                    <b-button @click="synchronizeNbb()" variant="secondary"
                      >Synchroniser</b-button
                    >
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <!-- <b-tab> </b-tab> -->

            <template #tabs-end>
              <li v-if="editable" class="nav--item ml-auto mt--1">
                <b-button
                  @click="save"
                  variant="success"
                  size="sm"
                  :disabled="dataChanged ? false : true"
                  >Enregistrer les modifications</b-button
                >
              </li>
            </template>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import debtors from "@/services/debtors.js";
import bce from "@/services/bce.js";
import DateTime from "@/services/DateTime.js";
import MhInput from "@/components/MhInput.vue";
import MhTableEditable from "@/components/MhTableEditable.vue";
export default {
  name: "debtor-view",
  components: { MhInput, MhTableEditable },
  props: {
    edit: {
      type: Boolean,
      default: true,
    },
    _new: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => {
        return {
          tab: "",
        };
      },
    },
  },
  data() {
    return {
      debtor: {},
      bce: {},
      id: 0,
      render: 0,
      editable: false,
      publications: {},
      new_address: false,
      fieldsTel: [
        {
          key: "tel",
          label: "Numéro",
          type: "varchar",
        },
        {
          key: "description",
          label: "Description",
          type: "varchar",
        },
        {
          key: "sms",
          label: "SMS auto",
          type: "enum",
          options: [
            { label: "SMS automatique", value: "yes" },
            { label: "Pas de SMS", value: "no" },
          ],
          default: "no",
        },
      ],
      open_warrants_fields: [
        {
          key: "ID",
          class: "text-center",
        },
        {
          key: "status",
          class: "text-center",
          formatter: (value) => {
            switch (value) {
              case "stopped":
                return "à l'agenda";
              case "open":
                return "ouvert";
            }
            return "";
          },
        },
        {
          key: "date_creation",
          label: "Date de création",
          formatter: (value) => this.toDate(value),
          sortable: true,
        },
        {
          key: "creancier",
          label: "Créancier",
          sortable: true,
        },
        {
          key: "arrangementID",
          label: "Arrangement",
          class: "text-center",
        },
        {
          key: "reinit_procedure",
          label: "Réinitialiser la procédure courrier",
          class: "text-center",
        },
        {
          key: "update_address",
          label: "Mettre à jour l'adresse du mandat",
          class: "text-center",
        },
      ],
      pubfields: [
        {
          key: "id",
        },
        {
          key: "timestamp",
          label: "Date",
          sortable: true,
        },
        {
          key: "infos",
          label: "Publications",
          sortable: true,
        },
        {
          key: "document",
          label: "Document",
          sortable: false,
        },
      ],
      nbb_fields: [
        {
          key: "deposit_date",
          label: "Date de dépôt",
          sortable: true,
          formatter: (el) => this.toDate(el),
        },
        {
          key: "type",
          label: "Type",
        },
        {
          key: "model_name",
          label: "Nom du modèle",
        },
        {
          key: "reference",
          label: "Référence",
        },
        {
          key: "period_end_date",
          label: "Date de fin d'exercice",
          sortable: true,
          formatter: (el) => this.toDate(el),
        },
        {
          key: "language",
          label: "Langue",
        },
        {
          key: "actions",
          label: "",
        },
      ],
      addressesFields: [
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "nom",
          label: "Identité",
          sortable: true,
        },
        {
          key: "adresse",
          label: "Adresse",
        },
        {
          key: "codepostal",
          label: "Localité",
          sortable: true,
        },
        {
          key: "pays",
          label: "Pays",
          sortable: true,
        },
      ],

      mandatsFields: [
        {
          key: "ID",
          label: "#",
          sortable: true,
        },
        {
          key: "date_ouverture",
          label: "Date d'ouverture",
          sortable: true,
        },
        {
          key: "status",
          label: "Statut",
          sortable: true,
        },
        {
          key: "nom_soc",
          label: "Créancier",
          sortable: true,
        },
        {
          key: "solde_du",
          label: "Solde du dossier",
        },
      ],
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Débiteurs",
          to: { name: "debtors" },
        },
        {
          text: "",
          active: true,
        },
      ],
      loaded: false,
      bceLoaded: false,
      dataChanged: false,
      publicationsLoaded: false,
    };
  },
  watch: {
    $route() {
      // react to route changes...
      this.id = this.$route.params.id;
      this.load(true);
    },
  },
  created() {
    if (this._new) {
      this.id = 0;
    } else {
      this.id = this.$route.params.id;
    }
    if (this.$store.getters.isAdmin) {
      this.editable = true;
    } else {
      this.editable = false;
    }
    this.load(true);
  },
  computed: {
    mandatsTotal() {
      return this.twoDigits(
        this.debtor.debiteur_mandats.reduce(
          (a, b) => a + parseFloat(b.soldeDu.soldeDu),
          0
        )
      );
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (this.dataChanged) {
      await this.$root.$bvModal
        .msgBoxConfirm(
          "Des modifications ont été apportés à ce débiteur. Enregistrer?",
          {
            cancelTitle: "Non",
            okTitle: "Oui",
          }
        )
        .then((value) => {
          if (value) {
            this.save();
          }
          next(false);
        })
        .catch(() => next());
    } else {
      next();
    }
  },
  methods: {
    getNbbUrl(id) {
      return this.$store.getters.url + "/nbb/" + id + "/pdf";
    },
    presave() {
      this.dataChanged = true;
    },
    synchronizeNbb() {
      bce.synchronizeNbb(this.debtor.tva.value).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Débiteur syncrhonisé", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          this.load();
        } else {
          this.$bvToast.toast("Pas de résultats", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "info",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    },
    reloadTitres() {
      debtors.get_titres(this.debtor.langue.value).then((response) => {
        this.debtor.titredebiteurID.options = response.data;
      });
      this.dataChanged = true;
    },
    load(addBread = false) {
      debtors.get(this.id).then((response) => {
        this.debtor = response.data;
        this.$store.dispatch("history", {
          object: "debiteur",
          objectID: this.debtor.ID.value,
          message: "Consultation du débiteur",
          data: {},
        });
        if (addBread) {
          this.items[2] = {
            text:
              this.debtor.nom_soc.value.trim() !== ""
                ? this.debtor.nom_soc.value
                : this.debtor.prenom.value + " " + this.debtor.nom.value,
            active: true,
          };
        }

        this.loaded = true;
        bce.get(this.debtor.tva.value).then((response) => {
          this.bce = response.data;
          this.bceLoaded = true;
        });
        bce.getPublications(this.debtor.tva.value).then((response) => {
          this.publications = response.data;
          this.publicationsLoaded = true;
        });
        this.render++;
      });
    },
    suggestAddress(payload) {
      this.debtor.rue1.value = payload.route || "";
      if (payload.street_number) {
        this.debtor.rue1.value += ", " + payload.street_number;
      }
      this.debtor.rue2.value = "";
      this.debtor.localite.value = payload.city || "";
      this.debtor.pays.value = payload.country || "";
      this.debtor.codepostal.value = payload.postal_code || "";
    },
    save() {
      this.dataChanged = false;
      debtors.post(this.debtor).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Débiteur enregistré", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          if (this._new) {
            this.$router.push({
              name: "debtorEdit",
              params: { id: response.data.id },
            });
          }
          for (let el in this.debtor) {
            if (typeof this.debtor[el] == "object") {
              this.debtor[el].error = false;
            }
          }
          this.items[2] = { text: this.debtor.nom_soc.value, active: true };
          this.renderBreadCrumb++;
          if (response.data.new_address) {
            this.new_address = true;
          }
          this.load(true);
        } else if (response.data.fail) {
          for (let el in this.detbtor) {
            this.debtor[el].error = false;
          }
          response.data.fail.forEach((element) => {
            this.debtor[element.field].error = element.errors.join(" ; ");
          });
        } else if (response.data.error) {
          this.$bvToast.toast("Erreur : " + response.data.error, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    },
    nl2br(str) {
      return str.replace(/\n/g, "<br/>");
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.pre-formatted {
  white-space: pre;
}
</style>
